module.exports = __webpack_public_path__ + "img/stories-from-the-threshold.dbf509c6.jpg";